// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3hrVB","additionalInfo":"AgreementModal_additionalInfo__1XMUt"};